import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f268a068"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup_form"
}
const _hoisted_2 = { class: "popup_head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "弹窗广告", -1))
const _hoisted_4 = { class: "form_content" }
const _hoisted_5 = {
  key: 1,
  class: "form_avatar"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "form_name" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "定时", -1))
const _hoisted_12 = { class: "timing_content" }
const _hoisted_13 = { class: "timing_switch public" }
const _hoisted_14 = { class: "eject_times public" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "open_popup" }, "(即可弹出)", -1))
const _hoisted_16 = {
  key: 0,
  class: "single_timing public"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "时间需为当日未到达时段", -1))
const _hoisted_18 = {
  key: 1,
  class: "punch_duration public"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "duration_time" }, "间隔时长:", -1))
const _hoisted_20 = { class: "drawer_footer" }
const _hoisted_21 = { class: "btn_group" }
const _hoisted_22 = { style: {"color":"#999999"} }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#00ccb0"} }, "添加", -1))

import { ref } from 'vue';
import { Popover, Button, message, Radio, DatePicker, InputNumber, Empty } from 'ant-design-vue';
import { CloseOutlined, QuestionCircleFilled } from '@ant-design/icons-vue';
// import PopupTiming from './PopupTiming.vue';
import { useRoute } from 'vue-router';
import http from '@/api';
import { expressDom } from './type';
import { emptyAdverst } from '@/assets';


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupAdverst',
  emits: ['click:onCloseLotter'],
  setup(__props, { emit }) {

const aPopover = Popover;
const aButton = Button;
const aEmpty = Empty;
const aInputNumber = InputNumber;
const createGift = ref(true); //弹窗广告页面
const Popup = ref<expressDom[]>([]);
const route = useRoute();
const aDatePicker = DatePicker;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
// const emit = defineEmits(['createStatus']);
const open = ref(1);
const virtualNum = ref(0);
const intervalLength = ref(0);
const isShowes = ref(1);

const goBack = () => {
  // emit('createStatus', true);
  createGift.value = !createGift.value;
};
const strValue = ref<any>('');
const cancel = () => {
  createGift.value = !createGift.value;
};
const formId = ref(0);
const onBlack = () => {
  setStudioAdTiming(formId.value);
};
// const getCreateStatus = (data: any) => {
//   createGift.value = data;
// };


const goDelete = () => {
  emit('click:onCloseLotter');
};
const fixTime = (adId: number) => {
  createGift.value = false;
  formId.value = adId;
  sdTimingInfo(adId);
};
// 获取直播间弹窗广告列表
const studioAdList = () => {
  let adlist = {
    studio_id: route.params.studioId,
  };
  http.liveExpress
    .getStudioAdList({ params: adlist })
    .then((res) => {
      const degress = res.data.data.elastic_list ? res.data.data.elastic_list : [];
      Popup.value = degress;
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
studioAdList();
// 获取直播间弹窗广告信息
const sdTimingInfo = (adId: number) => {
  let sdtime = {
    studio_id: route.params.studioId,
    ad_id: adId,
  };
  http.liveExpress
    .getSdTimingInfo({ params: sdtime })
    .then((res) => {
      const elastic = res.data.data;
      open.value = elastic.status;
      virtualNum.value = elastic.type;
      strValue.value = elastic.timing_at;
      intervalLength.value = elastic.interval_length;
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
// 设置直播间弹窗弹出
const setStudioAdElastic = (adId: number) => {
  let adelast = {
    studio_id: route.params.studioId,
    ad_id: adId,
  };
  http.liveExpress
    .getSetStudioAdElastic(adelast)
    .then((res) => {
      if (res.data.code == 200) {
        message.destroy();
        message.success(res.data.message);
      }
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};
// 设置直播间弹窗广告定时任务
const setStudioAdTiming = (adId: number) => {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (month < 10) {
    month = '0' + month;
  }
  if (day < 10) {
    day = '0' + day;
  }
  let adTiming = {
    studio_id: route.params.studioId,
    id: adId,
    interval_length: intervalLength.value,
    status: open.value,
    timing_at: virtualNum.value == 0 ? strValue.value : '',
    type: virtualNum.value,
  };
  http.liveExpress
    .getSetStudioAdTiming(adTiming)
    .then((res) => {
      message.destroy();
      message.success(res.data.message);
    })
    .catch((res) => {
      message.destroy();
      message.error(res.data.error);
    });
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (createGift.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", {
              class: "timing_return",
              onClick: goDelete
            }, [
              _createVNode(_unref(CloseOutlined))
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Popup.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "form_select"
              }, [
                (item.type == 2)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["form_avatar", { cutAvatar: isShowes.value ? isShowes.value == 1 : '' }])
                    }, [
                      _createElementVNode("p", null, _toDisplayString(item.title), 1),
                      _createElementVNode("p", null, _toDisplayString(item.content), 1)
                    ], 2))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("img", {
                        src: item.content,
                        alt: ""
                      }, null, 8, _hoisted_6)
                    ])),
                _createElementVNode("div", _hoisted_7, _toDisplayString(item.elastic_type_title), 1),
                _createElementVNode("div", {
                  class: "form_timing",
                  onClick: ($event: any) => (fixTime(item.id))
                }, [
                  _createVNode(_unref(aPopover), { placement: "top" }, {
                    content: _withCtx(() => [
                      _createTextVNode(" 定时 ")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(aButton), { type: "link" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, { "icon-class": "control_timing" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_8),
                _createElementVNode("div", {
                  class: "form_eject",
                  onClick: ($event: any) => (setStudioAdElastic(item.id))
                }, [
                  _createVNode(_unref(aPopover), { placement: "top" }, {
                    content: _withCtx(() => [
                      _createTextVNode(" 弹出 ")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(aButton), { type: "link" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, { "icon-class": "control_eject" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_9)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (!createGift.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", { class: "Timing_nav" }, [
            _hoisted_11,
            _createElementVNode("div", {
              class: "timing_return",
              onClick: goBack
            }, "返回 >>")
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createTextVNode(" 功能开关 "),
              _createVNode(_component_a_switch, {
                checked: open.value,
                "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event)),
                class: "btns_txt",
                "checked-value": 1,
                "un-checked-value": 0
              }, null, 8, ["checked"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createTextVNode(" 弹出次数: "),
              _createVNode(_unref(aRadioGroup), {
                value: virtualNum.value,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((virtualNum).value = $event)),
                class: "number_open"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aRadio), { value: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("单次"),
                      _hoisted_15
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(aRadio), { value: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("多次")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]),
            (virtualNum.value == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createTextVNode(" 单次定时: "),
                  _createVNode(_unref(aDatePicker), {
                    value: strValue.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((strValue).value = $event)),
                    "show-time": "",
                    format: "YYYY-MM-DD HH:mm:ss",
                    class: "time_picker"
                  }, null, 8, ["value"]),
                  _createVNode(_unref(aPopover), { placement: "right" }, {
                    content: _withCtx(() => [
                      _hoisted_17
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(QuestionCircleFilled), { class: "QuestionCircleFilled" })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (virtualNum.value == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_unref(aInputNumber), {
                    id: "inputNumber",
                    value: intervalLength.value,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((intervalLength).value = $event)),
                    min: 0,
                    max: 100,
                    class: "current_input"
                  }, null, 8, ["value"]),
                  _createTextVNode(" 分钟/次 ")
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_unref(aButton), {
                class: "mod_modal_btn",
                onClick: cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }),
              _createVNode(_unref(aButton), {
                class: "mod_modal_btn mod_type_primary",
                onClick: onBlack
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (Popup.value.length === 0)
      ? (_openBlock(), _createBlock(_unref(aEmpty), {
          key: 2,
          class: "empty_wrap",
          image: _unref(emptyAdverst)
        }, {
          description: _withCtx(() => [
            _createElementVNode("span", _hoisted_22, [
              _createTextVNode("空空如也，去"),
              _createVNode(_component_router_link, {
                to: { path: `/market/${_unref(route).params.studioId}/advertising` },
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              }, 8, ["to"]),
              _createTextVNode("弹窗广告吧")
            ])
          ]),
          _: 1
        }, 8, ["image"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})